

import { BaseTranslatableModel } from './BaseTranslatableModel';
import { Instance, types } from 'mobx-state-tree';

export const StaticFrameModel = types.model('StaticFrameModel', {
  type: types.string,
  mainTitle: types.optional(types.string, ''),
  secondaryTitle: types.optional(types.string, ''),
  thirdTitle: types.optional(types.string, ''),
  text: types.array(BaseTranslatableModel),
  image: types.maybe(types.string),
  /** memoCard frames: emoji drawn on the tile */
  emoji: types.maybe(types.string),
});


export type IStaticFrameModel = Instance<typeof StaticFrameModel>;